import Image from 'next/image';
import { convertPrice } from '../../../../Utils/ForeignUtils';
import { sizeMapping } from '../../../MaternityWear/constants';
import {
  cartFillerProductId,
  cartFillerProductIdMB,
  diaperCartFillerProductId,
  showCartFiller,
} from '../Constants';
import AddDeleteCartButtons from './AddDeleteCartButtons';
import {
  CartDiscountPercentage,
  CartFillerStrikePrice,
  CartProductSection,
  FreeTag,
  ItemDetail,
  ProductImageSection,
  SpecialOfferStrip,
  TotalPriceInCart,
} from './styled';
import { useState } from 'react';
import { useRouter } from 'next/router';
import { getRouterLocale } from '../../../../Utils/i18Utils/constant';
import { clicked_cart_image } from '../instrumentation';
import { queryParamHandling } from '../../../../Utils/productPageUtils';

export default function CartProducts(props) {
  const {
    product,
    setSnackBarMessage,
    offerProduct,
    offerId,
    offerListFetcher,
    paymentPage,
    isB2G1SkuAdded,
    isConsultationProduct,
  } = props;
  const productImage = product?.images?.[0];
  const { symbol, price: productPrice } = convertPrice(product?.price);
  const { price: strikePrice } = convertPrice(product?.strikeprice);
  const discount_percent = product?.discountPercent;
  const [cardEffect, setCardEffect] = useState(false);
  const router = useRouter();
  // const isSample =
  //     product.hasOwnProperty("is_sample") && product.is_sample === "1"
  //         ? true
  //         : false;
  const showCartFillerStrip =
    diaperCartFillerProductId.includes(product?.id?.toString()) ||
    product?.id === JSON.parse(cartFillerProductId) ||
    (product?.id === JSON.parse(cartFillerProductIdMB) && showCartFiller());

  const sizeValue = product?.size
    ? sizeMapping[product?.size]
      ? sizeMapping[product?.size]
      : product?.size
    : null;

  const getPriceSectionCart = (isConsultationProduct) => {
    return (
      <TotalPriceInCart>
        {isConsultationProduct ? (
          <span className="freeText">FREE</span>
        ) : (
          <span>
            {symbol}
            {`${offerProduct ? productPrice : productPrice * product?.quantity}
                    `}
          </span>
        )}
        {discount_percent > 0 || product?.price === 0 ? (
          <CartFillerStrikePrice>
            {symbol}
            {strikePrice}
          </CartFillerStrikePrice>
        ) : null}
        {discount_percent > 0 ? (
          <CartDiscountPercentage>
            {product?.price == 0 ? '100% Off' : discount_percent + '% Off'}
          </CartDiscountPercentage>
        ) : null}
      </TotalPriceInCart>
    );
  };
  const onClickImage = () => {
    clicked_cart_image(product?.id, product?.web_url);
    setCardEffect('lowOpac');
    setTimeout(() => {
      const { addParams, newUrl } = queryParamHandling(product?.web_url);
      router.push(newUrl + addParams, '', {
        locale: getRouterLocale(router),
      });
    }, [200]);
    setTimeout(() => {
      setCardEffect('');
    }, [2000]);
  };
  return isConsultationProduct ? (
    <CartProductSection
      className={cardEffect}
      backgroundColor={false}
      paymentPage={paymentPage}
    >
      <ProductImageSection>
        <Image
          src={productImage}
          width={68}
          height={68}
          quality={90}
          alt="Product"
        />
      </ProductImageSection>

      <ItemDetail>
        <p className="product_name">{product?.nickname}</p>
        {product?.description ? (
          <p className="product_description">{product?.description}</p>
        ) : null}
        {/* <FlexCenterVSpaceBH> */}
        {/* {isSample ? (
                <p className="pack_of_item">Pack for 10 wipes</p>
            ) : ( */}
        {/* {!showCartFillerStrip &&  */}
        {getPriceSectionCart(isConsultationProduct)}
        {/* } */}
        {/* )} */}
        {/* </FlexCenterVSpaceBH> */}
        <AddDeleteCartButtons
          itemData={product}
          setSnackBarMessage={setSnackBarMessage}
          offerId={offerId}
          showCartFillerStrip={showCartFillerStrip}
          offerListFetcher={offerListFetcher}
          getPriceSectionCart={getPriceSectionCart}
          isB2G1SkuAdded={isB2G1SkuAdded}
          isConsultationProduct={isConsultationProduct}
        />
      </ItemDetail>
    </CartProductSection>
  ) : (
    <CartProductSection
      className={cardEffect}
      onClick={onClickImage}
      backgroundColor={false}
      paymentPage={paymentPage}
    >
      <ProductImageSection>
        <Image
          src={productImage}
          width={68}
          height={68}
          quality={90}
          alt="Product"
        />

        {/* <img
                src={productImage}
                srcSet={`${productImage}?tr=w-136 1x, ${productImage}?tr=w-136 2x, ${productImage}?tr=w-204 3x`}
                alt={product?.name}
                className="product_image"
            /> */}
        {product?.price == 0 && <FreeTag src="/images/freetag.svg" alt="" />}
      </ProductImageSection>

      <ItemDetail>
        {showCartFillerStrip ? (
          <SpecialOfferStrip>Special offer just for you</SpecialOfferStrip>
        ) : null}

        <p className="product_name">{product?.nickname}</p>
        {product?.pack_type ? (
          <p className="pack_of_item">{product?.pack_type}</p>
        ) : null}

        {sizeValue ? <p className="size_of_item">Size: {sizeValue}</p> : null}

        {product?.discount_message ? (
          <p className="discount_message">{product?.discount_message}</p>
        ) : null}
        {/* <FlexCenterVSpaceBH> */}
        {/* {isSample ? (
                    <p className="pack_of_item">Pack for 10 wipes</p>
                ) : ( */}
        {/* {!showCartFillerStrip &&  */}
        {getPriceSectionCart()}
        {/* } */}
        <AddDeleteCartButtons
          itemData={product}
          setSnackBarMessage={setSnackBarMessage}
          offerId={offerId}
          showCartFillerStrip={showCartFillerStrip}
          offerListFetcher={offerListFetcher}
          getPriceSectionCart={getPriceSectionCart}
          isB2G1SkuAdded={isB2G1SkuAdded}
          isConsultationProduct={isConsultationProduct}
        />
        {/* )} */}
        {/* </FlexCenterVSpaceBH> */}
      </ItemDetail>
    </CartProductSection>
  );
}
